import { useState } from 'react';
import { Link } from 'react-router-dom';
import { brand, contactEmail, whatsappUrl, instagramUrl, whatsappLink } from '../../config/brand';

const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    const email = newsletterEmail.trim();
    if (!email) return;
    const message = `Hi Aabha, I'd like to get updates on new workshops, upcoming dates, and limited-seat experiences. Please add me to your list.\n\nMy email: ${email}`;
    window.open(whatsappLink(message), '_blank', 'noopener,noreferrer');
    setNewsletterEmail('');
  };

  return (
  <footer id="mainFooter">
    <div className="footer-top">
      <div className="footer-brand">
        <Link to="/" className="footer-logo-link" aria-label={`${brand.name} - Home`}>
          <img
            src="/assets/Logo 1.PNG"
            alt={brand.logoAlt}
            className="footer-logo"
            decoding="async"
            data-keep-image="true"
          />
        </Link>
        <span className="logo">{brand.name}</span>
        <p>
          {brand.name} designs premium, hands-on workshops in Bangalore that help people connect through creativity — from
          Kintsugi and weekend café sessions to corporate team building and private celebration formats across Karnataka.
        </p>
        <p className="footer-tagline">{brand.shortTagline}</p>
      </div>
      <div className="footer-col">
        <h4>Explore</h4>
        <ul>
          <li>
            <Link to="/workshops">Art workshops in Bangalore</Link>
          </li>
          <li>
            <Link to="/corporate">Corporate workshops Bangalore</Link>
          </li>
          <li>
            <Link to="/events">Private celebration workshops</Link>
          </li>
          <li>
            <Link to="/calendar">Upcoming weekend workshops</Link>
          </li>
          <li>
            <Link to="/gallery">Workshop gallery</Link>
          </li>
        </ul>
      </div>
      <div className="footer-col">
        <h4>Company</h4>
        <ul>
          <li>
            <Link to="/about">Our Story</Link>
          </li>
          <li>
            <Link to="/contact">Contact Workshops by Aabha</Link>
          </li>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/terms">Terms &amp; Guidelines</Link>
          </li>
          <li>
            <Link to="/cancellation-refund">Cancellation &amp; Refund</Link>
          </li>
        </ul>
      </div>
      <div className="footer-newsletter">
        <h4>Stay Updated</h4>
        <p>Get updates on new workshops, upcoming dates, and limited-seat experiences.</p>
        <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
          <input
            type="email"
            name="newsletter-email"
            autoComplete="email"
            required
            placeholder="Your email address"
            value={newsletterEmail}
            onChange={(e) => setNewsletterEmail(e.target.value)}
            aria-label="Email for workshop updates"
          />
          <button type="submit">Subscribe</button>
        </form>
      </div>
    </div>
    <div className="footer-bottom">
      <span>(c) 2026 {brand.name} - All rights reserved</span>
      <span>
        <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
        {' | '}
        <a href={whatsappUrl} target="_blank" rel="noreferrer">
          WhatsApp
        </a>
        {' | '}
        <a href={`mailto:${contactEmail}`}>Email</a>
      </span>
    </div>
  </footer>
  );
};

export default Footer;
